import React, { useEffect } from 'react'

import { CurrentScreenType } from '@/entities/userInterface/model/CurrentScreenType'
import { upsertOneWidgetWindow } from '@/entities/widgetWindows'
import { CustomGridToolbar } from '@/shared/components/GridTable/CustomGridToolbar'
import { GridTable } from '@/shared/components/GridTable/GridTable'
import { TOOL_WIDGETS, WidgetTypeWithSuffix } from '@/shared/components/Mosaic/models/widgetType'
import { useAppDispatch, useAppSelector } from '@/shared/store'
import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons'
import { GridColDef } from '@mui/x-data-grid-premium'

import { useViolationData } from './libs/useViolationsData'

export type OperationsViolationWidgetProps = {
  id: string
  widgetId: WidgetTypeWithSuffix // Widget Window id
}

export const OperationsViolationsWidget: React.FC<OperationsViolationWidgetProps> = ({ widgetId }) => {
  const currentScreen = useAppSelector(state => state.userInterface.currentScreen)
  const { violations, loading } = useViolationData()

  const dispatch = useAppDispatch()

  // Update widget window context and global store to render widow title, uiColor, etc.
  useEffect(() => {
    if (widgetId) {
      dispatch(upsertOneWidgetWindow({
        id: widgetId,
        isActive: true,
        widgetType: TOOL_WIDGETS.Violations,
        navigations: [
          {
            title: 'Violations',
            icon: faTriangleExclamation,
          },
        ],
      }))
    }
  }, [widgetId, dispatch])

  const rows = violations.map((violation, idx) => ({
    id: idx,
    ...violation,
  }))

  const getColumns = (cs: CurrentScreenType): GridColDef[] => [
    {
      field: cs === 'planning' ? 'scenarioName' : 'runsheetName',
      headerName: cs === 'planning' ? 'Scenario' : 'Runsheet',
      width: 100,
      filterable: true,
      sortable: true,
      pinnable: false,
      type: 'string',
      description: cs === 'planning' ? 'Scenario with violation' : 'Runsheet with violation',
    },
    {
      field: 'runName',
      headerName: 'Run',
      width: 100,
      filterable: true,
      sortable: true,
      pinnable: false,
      type: 'string',
      description: 'Run having the violation',
    },
    {
      field: 'orderNumber',
      headerName: 'Order',
      width: 100,
      filterable: true,
      sortable: true,
      pinnable: false,
      type: 'string',
      description: 'Order having the violation',
    },
    {
      field: 'hint',
      headerName: 'Violation Description',
      width: 300,
      filterable: true,
      sortable: true,
      pinnable: false,
      type: 'string',
      description: 'Violation description',
    },
  ]
  const columns = getColumns(currentScreen)

  return (
    <GridTable
      rows={rows}
      columns={columns}
      loading={loading}
      isDragDropEnabled={false}
      initialState={{
        filter: {
          filterModel: {
            items: [{
              field: 'isActive', operator: 'equals', value: 'Active',
            }],
          },
        },
      }}
      slots={{
        toolbar: CustomGridToolbar,
      }}
      sx={{
        '.MuiDataGrid-filler--pinnedRight': { display: 'none' },
      }}
    />
  )
}
